import type { SmartCreationReviewEntityRef } from "../schemas/smart-creation-review";

export type SmartCreationReviewErrorCode =
  | "smart_creation.campaign_dates_invalid"
  | "smart_creation.capability_unsupported"
  | "smart_creation.plan_immutable"
  | "smart_creation.promotion_dates_invalid"
  | "smart_creation.review_ai_policy_invalid"
  | "smart_creation.review_all_campaigns_excluded"
  | "smart_creation.review_bid_invalid"
  | "smart_creation.review_bidding_strategy_invalid"
  | "smart_creation.review_budget_invalid"
  | "smart_creation.review_name_invalid"
  | "smart_creation.review_negative_invalid"
  | "smart_creation.review_not_confirmable"
  | "smart_creation.review_placement_invalid"
  | "smart_creation.review_revision_conflict"
  | "smart_creation.review_schedule_invalid"
  | "smart_creation.review_target_changed"
  | "smart_creation.review_target_invalid"
  | "smart_creation.revision_conflict";

/** Platform-neutral validation error; API adapters map it to their HTTP error type. */
export class SmartCreationReviewError extends Error {
  constructor(
    public statusCode: number,
    public code: SmartCreationReviewErrorCode,
    message: string,
    public details?: unknown,
  ) {
    super(message);
    this.name = "SmartCreationReviewError";
  }
}

export function reviewTargetMissing(ref: SmartCreationReviewEntityRef): SmartCreationReviewError {
  return new SmartCreationReviewError(
    409,
    "smart_creation.review_target_changed",
    "The edited draft item no longer exists in the current Review",
    { kind: ref.kind, lineageKey: ref.lineageKey },
  );
}
